/**
 * WhatsApp click-to-chat badge.
 * Green pill containing the official WhatsApp logo (mono white) and the dial-able number.
 * Clicking opens the official wa.me deep-link.
 */
export default function WhatsAppBadge({
  number = "254730729729",
  display = "+254 730 729 729",
  testid = "whatsapp-badge",
  message,
  className = "",
}) {
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  const href = `https://wa.me/${number}${text}`;
  return (
    <a
      className={`tn-wa-badge ${className}`}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Chat with Tandaa on WhatsApp ${display}`}
      data-testid={testid}
    >
      <svg className="tn-wa-icon" viewBox="0 0 32 32" aria-hidden="true">
        <path
          fill="#FFFFFF"
          d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.063 0-.117-.023-.197-.058-.69-.305-2.297-1.094-3.298-2.42-.187-.255-.181-.382.012-.616.27-.328.802-.811.803-1.252 0-.236-1.06-2.62-1.21-2.745-.087-.073-.198-.123-.347-.123h-.476c-.171 0-.477.069-.732.352-.366.405-.957 1.215-.957 2.586 0 1.371.962 2.69 1.124 2.901.187.244 2.018 3.231 5.046 4.464.812.327 1.445.518 1.94.667.815.247 1.559.213 2.144.131.654-.094 2.01-.85 2.292-1.673.282-.823.282-1.523.197-1.673-.087-.157-.305-.244-.624-.401-.319-.157-1.886-.957-2.18-1.066-.293-.108-.504-.157-.715.157zM16.013 27.99c-2.13 0-4.221-.55-6.077-1.595l-6.717 1.776 1.815-6.617c-1.143-1.93-1.747-4.135-1.747-6.41 0-6.927 5.636-12.563 12.563-12.563s12.563 5.636 12.563 12.563-5.637 12.563-12.563 12.563zm0-22.617c-5.546 0-10.06 4.514-10.06 10.06 0 2.107.654 4.13 1.882 5.844l.236.337-1.067 3.89 3.972-1.06.325.193c1.629.967 3.493 1.479 5.395 1.479 5.546 0 10.06-4.514 10.06-10.06s-4.514-10.06-10.06-10.06z"
        />
      </svg>
      <span className="tn-wa-number" data-testid={`${testid}-number`}>{display}</span>
    </a>
  );
}
